/**
 * Spec 2026-08-28-waiter-salle-ux-design.md §2.7 — live-review finding M1.
 * `OnlineOrderRow` used to render the customer phone verbatim
 * ("0612345678"), unreadable at a glance on a 390px handheld. This formats a
 * French national or E.164 number for display without touching the raw
 * value used elsewhere (e.g. the `tel:` link in `OnlineOrderDetailModal`).
 * Anything that isn't a recognised French shape is returned unchanged
 * (trimmed) rather than mangled — the backend is free to send foreign
 * numbers.
 */
export function formatPhone(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed === '') return '';
  const stripped = trimmed.replace(/[\s.-]/g, '');

  if (/^0\d{9}$/.test(stripped)) {
    return stripped.replace(/(\d{2})(?=\d)/g, '$1 ');
  }

  if (/^\+33\d{9}$/.test(stripped)) {
    const national = stripped.slice(3);
    const grouped = national.replace(/(\d)(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
    return `+33 ${grouped}`;
  }

  return trimmed;
}
